import {
  Container,
  ButtonContainer,
} from "./styles";
import Button from "../../../Defaulters/components/button";

import { ExclamationCircleOutlined } from "@ant-design/icons";

function ConfirmationModalContent({
  confirmationFunction,
  cancelFunction,
  confirmationText,
  cancelText,
  description,
  isLoading,
}) {
  function closeContent() {
    cancelFunction();
  }

  function handleConfirmation() {
    if (isLoading) {
      return;
    }
    confirmationFunction();
  }

  return (
    <Container>
      <ExclamationCircleOutlined
        style={{
          width: "64px",
          height: "64px",
          color: "#002244",
        }}
      />
      <p>{description}</p>
      <ButtonContainer width="100%">
        <Button
          variant="secondary"
          label={cancelText}
          shadow
          onClick={() => closeContent()}
        />
        <Button
          label={confirmationText}
          shadow
          onClick={() => handleConfirmation()}
        />
      </ButtonContainer>
    </Container>
  );
}

export default ConfirmationModalContent;
